import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Title,
  createStyles,
  Avatar,
  Text,
  Select,
  Input,
  Group,
  Button,
  Tabs,
  SimpleGrid,
  Checkbox,
  Radio,
  Textarea,
  Progress,
} from "@mantine/core";
import { forwardRef } from "react";
import exclamationSvg from "../../assets/img/Exclamation.svg";
import { IconSettings, IconUser } from "@tabler/icons-react";
import { IconUsers } from "@tabler/icons-react";
import { StyledTabs } from "./StyledTabs";
import { IconMessageCircle } from "@tabler/icons-react";
import { platformLogo } from "../../utils";

const useStyles = createStyles(() => ({
  mainBox: {
    display: "flex",
    backgroundColor: "#F1F9FF",
    gap: "12px",
    width: "100%",
    padding: "12px",
    marginTop:"16px"
  },
  title: {
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "30px",
    color: "#262930",
  },
  title1: {
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "20px",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  title2: {
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#474E5B",
  },
  progressTitle: {
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#2C9D08",
  },
  progressTitle2: {
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "24px",
    color: "#262930",
  },
  progresBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  progresBoxmain: {
    display: "flex",
    flexDirection: "column",
    backgroundColor:"white",
    gap:"24px",
    padding:"12px"

  },
}));

export const RequestAccess = ({progress, total, done}:Record<string,number>) => {
  const { classes } = useStyles();

  return (
    <>
      <Box className={classes.mainBox}>
        <Box className={classes.row}>
          <Title align="center" className={classes.title}>
            Kick-off Request Status
          </Title>
            {" "}
          {/* <Box ml={24}>
            <Radio.Group>
              <Group mt="xs">
                <Radio value="HTTP" label="HTTP" />
                <Radio value="CURL" label="CURL" />
              </Group>
            </Radio.Group>
          </Box> */}
          <Box>
            <Button variant="outline">
              <Title sx={{ color: "#262930" }} className={classes.title1}>
                Refresh
              </Title>
            </Button>
          </Box> 
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#F1F9FF",
        }}
      >
        {/* <Title className={classes.title2}>
          After kicking off the bulk data request, use the status API to track
          the progress of the request
        </Title> */}
        {/* <Box>
          <Textarea size="lg" withAsterisk />
        </Box> */}
        <Box mt={24} p={8}>
          <Box className={classes.progresBoxmain}>
            <Box className={classes.progresBox}>
              {" "}
              <Title className={classes.progressTitle}>{done?'Completed':'In progress'}</Title>
              <Title className={classes.progressTitle2}>{isNaN(total) ? '--' : `${progress} %` }</Title>
            </Box>
            <Progress color="green" value={total?100*progress/total:0} />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default RequestAccess;
